import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/Header/Header'
import PhoneInput from '@components/PhoneInput/PhoneInput'
import NumericKeyboard from '@components/NumericKeyboard/NumericKeyboard'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import SimpleDropdown from '@components/SimpleDropdown/SimpleDropdown'
import AmountOption from '@components/AmountOption/AmountOption'
import { useNavigate } from 'react-router'
import {
  Container,
  ContentContainer,
  PhoneInputWrapper,
  DropdownWrapper,
  KeyboardSection,
  AmountSection,
  AmountLabel,
  AmountGrid,
  ButtonWrapper
} from './ESIMCredit.styles'

const ESIMCredit = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [step, setStep] = useState<'input' | 'amount'>('input')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneType, setPhoneType] = useState<string>('')
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null)

  const amounts = [
    { idr: 15000, jidr: 14500 },
    { idr: 25000, jidr: 24500 },
    { idr: 50000, jidr: 44500 },
    { idr: 65000, jidr: 64500 },
    { idr: 80000, jidr: 79500 },
    { idr: 100000, jidr: 99500 },
    { idr: 150000, jidr: 149500 },
    { idr: 200000, jidr: 194500 },
  ]

  const handleKeyboardChange = (value: string | 'delete') => {
    if (value === 'delete') {
      setPhoneNumber(prev => prev.slice(0, -1))
    } else {
      setPhoneNumber(prev => prev + value)
    }
  }

  const handleContinue = () => {
    if (step === 'input') {
      setStep('amount')
    } else {
      // Navigate to payment confirm page
      navigate('/payment-confirm', {
        state: {
          phoneNumber,
          phoneType,
          amount: selectedAmount,
          serviceType: 'esim-credit'
        }
      })
    }
  }

  const handleBack = () => {
    if (step === 'amount') {
      setStep('input')
    } else {
      navigate(-1)
    }
  }

  return (
    <Container>
      <Header
        title={t('esimCredit.header')}
        showBackButton={true}
        onBackClick={handleBack}
      />
      <ContentContainer>
        <PhoneInputWrapper>
          <PhoneInput
            value={phoneNumber}
            readOnly={step === 'input'}
            showPostpaidLabel={phoneType === t('esimCredit.postpaid')}
            iconType="e-sim"
          />
          {step === 'input' && (
            <DropdownWrapper>
              <SimpleDropdown
                placeholder={t('esimCredit.phoneTypePlaceholder')}
                options={[t('esimCredit.prepaid'), t('esimCredit.postpaid')]}
                value={phoneType}
                onChange={setPhoneType}
              />
            </DropdownWrapper>
          )}
        </PhoneInputWrapper>

        {step === 'input' ? (
          <KeyboardSection>
            <NumericKeyboard onChange={handleKeyboardChange} />
            <PrimaryButton
              onClick={handleContinue}
              disabled={!phoneNumber || !phoneType}
            >
              {t('esimCredit.continue')}
            </PrimaryButton>
          </KeyboardSection>
        ) : (
          <>
            <AmountSection>
              <AmountLabel>{t('esimCredit.chooseAmount')}</AmountLabel>
              <AmountGrid>
                {amounts.map((amount, index) => (
                  <div key={index} onClick={() => setSelectedAmount(amount.idr)}>
                    <AmountOption
                      idr={amount.idr}
                      jidr={amount.jidr}
                      selected={selectedAmount === amount.idr}
                    />
                  </div>
                ))}
              </AmountGrid>
            </AmountSection>
            <ButtonWrapper>
              <PrimaryButton
                onClick={handleContinue}
                disabled={!selectedAmount}
              >
                {t('esimCredit.continue')}
              </PrimaryButton>
            </ButtonWrapper>
          </>
        )}
      </ContentContainer>
    </Container>
  )
}

export default ESIMCredit
